function coerceBoolean(value, fallback = false) {
    if (value === undefined || value === null) return fallback;
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (normalized === 'true') return true;
        if (normalized === 'false') return false;
    }
    return Boolean(value);
}

function getPageLinkOverride(pageData = {}, key) {
    const value = pageData?.[key];
    const navCtaOverride =
        value && typeof value === 'object' && !Array.isArray(value)
            ? value
            : {};

    return {
        enabled: coerceBoolean(navCtaOverride.Enabled),
        link: String(navCtaOverride.Link || '').trim(),
    };
}

function applyPageNavCtaOverride(componentName, props = {}, pageData = {}) {
    const navCtaOverride = getPageNavCtaOverride(pageData);
    const outlineButtonOverride = getPageNavOutlineButtonOverride(pageData);
    if (componentName !== 'Nav') return props;
    const hasCtaOverride = navCtaOverride.enabled && navCtaOverride.link;
    const hasOutlineButtonOverride =
        outlineButtonOverride.enabled && outlineButtonOverride.link;
    if (!hasCtaOverride && !hasOutlineButtonOverride) return props;

    return {
        ...props,
        ...(hasCtaOverride ? { CustomCTALink: navCtaOverride.link } : {}),
        ...(hasOutlineButtonOverride
            ? { OutlineButtonLink: outlineButtonOverride.link }
            : {}),
    };
}

function getPageNavCtaOverride(pageData = {}) {
    return getPageLinkOverride(pageData, 'NavCtaOverride');
}

function getPageNavOutlineButtonOverride(pageData = {}) {
    return getPageLinkOverride(pageData, 'NavOutlineButtonOverride');
}

module.exports = {
    applyPageNavCtaOverride,
    getPageNavCtaOverride,
    getPageNavOutlineButtonOverride,
};
